import React, { useState } from 'react'
import useFetch from '../../../hooks/useAxios';

const BlogCat = () => {
    const [postCat, setpostCat] = useState([]); 
    const apiGetBlogCat= useFetch({
        method: "get",
        url: "api/posts_categories",
        noHeader: true,
        trigger: true,
        argFunc: res => setpostCat(res.data)
      });
  return (
    <div className='BlogSidebar-box'>
        <h2>دسته بندی ها</h2>
       {postCat.slice(0,5).map(i=> <div className='BlogCat-row'>
            <div className='BlogCat-row-p'>{i.title}</div>
            <div  className='BlogCat-row-box'>145</div>
        </div>
     ) }
    </div>
  )
}

export default BlogCat